import { selectFilterSpec } from '@ow/utils'

export { selectFilterSpec as filterSpec }

export const config = {
  etc: true, // 是否允许用户输入其他内容,比如一个选项叫：其他 。选择其他后，会渲染一个 input框，允许用户自己输入内容
  hint: '请输入', // plachholder
  slug: `select${Math.round(Math.random() * 100)}`,
  type: 'dropSelect',
  title: '选择', // 字段名称
  maxlen: 2,
  minlen: 2,
  remote: 'https://node-hnapi.herokuapp.com/news', // 从远程获取数据对应的url
  selects: [
    {
      slug: 'option1', // 唯一标识
      color: '#0152D9', // 颜色
      intro: '',
      score: 0,
      title: '选项1', // 文字
      value: 'option1', // 文字
      checked: false, // 是否被选中
      needInput: false, // 是否需要显示input,允许自定义输入内容，比如该选项title为“其他”，needInput:etc:true。 这时候会渲染一个Input框，允许用户自定义输入内容
      inputType: 'text',
      inputValue: '',
    },
    {
      slug: 'option2', // 唯一标识
      color: '#E34D59', // 颜色
      intro: '',
      score: 0,
      title: '选项2', // 文字
      value: 'option2', // 文字
      checked: false, // 是否被选中
      needInput: false, // 是否需要显示input,允许自定义输入内容，比如该选项title为“其他”，needInput:etc:true。 这时候会渲染一个Input框，允许用户自定义输入内容
      inputType: 'text',
      inputValue: '',
    },
    {
      slug: 'option3', // 唯一标识
      color: '#ED7B2F', // 颜色
      intro: '',
      score: 0,
      title: '选项3', // 文字
      value: 'option3', // 文字
      checked: false, // 是否被选中
      needInput: false, // 是否需要显示input,允许自定义输入内容，比如该选项title为“其他”，needInput:etc:true。 这时候会渲染一个Input框，允许用户自定义输入内容
      inputType: 'text',
      inputValue: '',
    },
    {
      slug: 'option4', // 唯一标识
      color: '#00A870', // 颜色
      intro: '',
      score: 0,
      title: '选项4', // 文字
      value: 'option4', // 文字
      checked: false, // 是否被选中
      needInput: false, // 是否需要显示input,允许自定义输入内容，比如该选项title为“其他”，needInput:etc:true。 这时候会渲染一个Input框，允许用户自定义输入内容
      inputType: 'text',
      inputValue: '',
    },
  ],
  multiple: false, // 是否多选
  readonly: false, // 是否只读
  required: false, // 是否必填
  hidden: false, // 是否隐藏
  description: '备注显示区域：进行详细的解释说明。', // 备注描述
  rangeSetting: false, // 是否现在范围，为true max min 才起效
  defaultChecked: [], // 默认选中的slug
}
